import { render, staticRenderFns } from "./FormalReceiptDialog.vue?vue&type=template&id=ffc4e848&scoped=true&"
import script from "./FormalReceiptDialog.vue?vue&type=script&lang=js&"
export * from "./FormalReceiptDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormalReceiptDialog.vue?vue&type=style&index=0&id=ffc4e848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc4e848",
  null
  
)

export default component.exports